import { makeApi, makeAuthenticatedApi } from 'core/api';
import { UsersApi } from 'api';

import type { User } from 'api';
import { Cmd } from 'redux-loop';
import { ApiError } from 'core/api/errors';

export async function verifyInitialAuthEffect(getState: Cmd.GetState): Promise<User> {
  // With session cookies, just try to fetch the current user
  // The session cookie is automatically sent by the browser
  return getUserEffect(getState);
}

export async function getUserEffect(getState: Cmd.GetState): Promise<User> {
  const usersApi = makeAuthenticatedApi(UsersApi, getState);
  const user = await usersApi.usersMeRetrieve();

  if (!user.email) {
    throw new ApiError();
  }

  return user;
}

export async function loginEffect(email: string, password: string, distributionPlatformName: string): Promise<User> {
  const usersApi = makeApi(UsersApi);

  const user = await usersApi.usersLoginCreate({
    sessionLoginRequest: {
      email,
      password,
      distributionPlatformName,
    },
  });

  if (!user.email) {
    throw new ApiError();
  }

  return user;
}

export async function logoutEffect(): Promise<void> {
  const usersApi = makeApi(UsersApi);
  try {
    await usersApi.usersLogoutCreate();
  } catch (e) {
    console.error('Logout failed:', e);
  }
}

export async function setUserLanguageEffect(language: string, getState: Cmd.GetState): Promise<User> {
  const usersApi = makeAuthenticatedApi(UsersApi, getState);

  return await usersApi.usersMePartialUpdate({
    patchedUserRequest: { language },
  });
}
